<template>
  <div
    class="evaluation-viewer-comment"
    v-if="comment"
  >
    <h6>COMENTARIO</h6>
    <main
      v-html="comment"
    />
  </div>
</template>

<script>
/**
   * 'EvaluationViewerComment' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerComment',
  props: {
    comment: {
      type: String,
      default: null
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-comment {
      h6{
        @include font-primary(14px, bold);
        display: block;
        margin: 30px 0 10px 0;
      }
      main{
        background-color: #f0f0f0;
        padding: 20px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-comment.vue